module.exports = 'https://civic66api.propertylaunch.ca/api/';